export default __webpack_public_path__ + "static/media/寿险.4ca215c3.jpg";